import { useParams } from 'react-router-dom';

import { AppUserContentReviewsPage } from '~/components/pages/AppUserContentReviewsPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { Navigate } from '~/components/utils/Navigation';

export const AppUserContentReviewsRoute: React.FC = () => {
  const { appId } = useParams();

  if (!appId) {
    return <Navigate to="/" />;
  }

  return (
    <DashboardTemplate appId={appId} hasAside>
      <AppUserContentReviewsPage appId={appId} />
    </DashboardTemplate>
  );
};
